import { atom } from 'jotai';

export type MapDataPopupCandidate = {
  title: string;
  properties: any;
  geometry?: any;
  mapDataId?: number;
  mapDataName?: string;
  sourceLayer?: string;
  featureId?: any;
};

export type MapDataLayerPopupProps = MapDataPopupCandidate & {
  lngLat: [number, number];
  items?: MapDataPopupCandidate[];
  selectedIndex?: number;
};

export const mapDataLayerPopupPropsAtom = atom<MapDataLayerPopupProps | null>(null);
